export default "__VITE_ASSET__BGu$yTUu__"